<template>
  <div id="cta">
    <div class="container text-center">
      <h4 class="text-secondary">
        {{ $t('contactUs.title') }}
      </h4>
      <p class="text-primary">
        {{ $t('contactUs.description') }}
      </p>

      <router-link class="btn btn-secondary me-4 px-4 my-4" to="/contact">
        {{ $t('contactUs.cta') }}
      </router-link>
    </div>
  </div>
</template>

<style scoped>
#cta {
  background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/call-to-action.png");
  background-size: 1800px;
  background-position: left bottom -150px;
  background-repeat: no-repeat;
  padding: 5em 0;
  min-height: 350px;
}

#cta h4 { 
  font-size: 1.5em;
  font-family: "Red Hat Display", sans-serif;
}
#cta p { 
  font-size: 2.5em;
  font-family: "DM Serif Display", serif;
}
.btn {
  font-family: "Red Hat Display", sans-serif;
  font-weight: bold;
}
</style>